import store from '@/store'
import network from '@/utils/network'

/**
 * Créé / met à jour un client
 * @returns {Promise<>}
 */
export const postAgencyCustomer = async (customer) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/customer`, customer)
  return r.data
}

/**
 * Supprimer un client
 * @returns {Promise<>}
 */
export const deleteAgencyCustomer = async ({ slug }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.delete(`agency/${slugAgency}/customer/${slug}`)
  return r.data
}
